import { NetworkStatus } from '@cbridge-utils/network';
import { ISymbolPriceStore } from './symbolPrice.interface';

export const symbolPriceInitialState: ISymbolPriceStore = {
  data: {},
  networkStatus: NetworkStatus.None,
};
